// import React, { useLayoutEffect } from "react";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { HelmetProvider } from "react-helmet-async";
import {
  createBrowserRouter,
  RouterProvider,
  // useLocation,
} from "react-router-dom";

// import Pages here
// Please order by route
import MainPage from "./pages/Main";
import AppointmentsPage from "./pages/Appointments";
import ImpressumPage from "./pages/Impressum";
import ErrorPageNotFound from "./pages/ErrorPageNotFoundSimple";
import GildefestPage from "./pages/Gildefest";

// const Wrapper = ({children}) => {
//   const location = useLocation();
//   useLayoutEffect(() => {
//     document.documentElement.scrollTo(0, 0);
//   }, [location.pathname]);
//   return children
// }

const helmetContext = {};

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainPage />,
    errorElement: <ErrorPageNotFound />,
  },
  {
    path: "appointments",
    element: <AppointmentsPage />,
  },
  // {
  //   path: "gildefest",
  //   element: <GildefestPage />,
  // },
  {
    path: "impressum",
    element: <ImpressumPage />,
  },
]);



ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider context={helmetContext}>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);
